export class ControlBase<T> {
    value: T|undefined;
    key: string;
    label: string;
    required: boolean;
    disabled: boolean;
    maxLength: number;
    order: number;
    controlType: string;
    type: string;
    options: {key: string, value: string}[];
  
    constructor(options: {
        value?: T;
        key?: string;
        label?: string;
        required?: boolean;
        disabled?: boolean;
        maxLength?: number;
        order?: number;
        controlType?: string;
        type?: string;
        options?: {key: string, value: string}[];
      } = {}) {
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label || '';
      this.required = !!options.required;
      this.disabled = !!options.disabled;
      this.maxLength = options.maxLength === undefined ? 1000 : options.maxLength;
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.type = options.type || '';
      this.options = options.options || [];
    }
  }